<template>
    <prism-editor class="my-editor" v-model="code" :highlight="highlighter" line-numbers></prism-editor>
</template>

<script>
// import Prism Editor
import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css'; // import the styles somewhere

// import highlighting library (you can use any library you want just return html string)
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-markup';
import 'prismjs/themes/prism-solarizedlight.css'; // import syntax highlighting styles

export default {
    components: {
        PrismEditor,
    },
    props: {
        value: {
            type: String,
            default: '',
        },
    },
    computed: {
        code: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },
    methods: {
        highlighter(code) {
            return highlight(code, languages.markup); // languages.<insert language> to return html with markup
        },
    },
};
</script>

<style>
/* required class */
.my-editor {
    background: #fffae2;
    border: 1px solid #fff0a9;
    border-radius: 4px;
    box-shadow: 1px 1px 7px rgba(0, 0, 0, 0.05);

    /* you must provide font-family font-size line-height. Example: */
    font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
    font-size: 14px;
    line-height: 1.5;
    padding: 5px;
}

/* optional class for removing the outline */
.prism-editor__textarea:focus {
    outline: none;
}

code[class*="language-"],
pre[class*="language-"] {
    overflow: auto !important;
    word-wrap: normal !important;
    white-space: pre !important;
}
</style>
